<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { mapActions } from 'vuex';

// This component is used to wrap the pieces of the app that are put behind authentication
export default {
  name: 'AuthWrapper',
  async created () {
    await this.getAgencyUser();
    await this.getRegistration();
    await this.getFeatureSwitches();
    var response = await this.$api.getAgency();
    if (response.code !== 0) {
      this.setError({ errorMessage: `Error - Unable to get agency information. Message: ${response.message}` });
      return;
    }
    this.setAgency(JSON.parse(response.data[0]));
    await this.getAgencyVersion();
  },
  methods: {
    ...mapActions(['setAgency', 'resetError', 'setError', 'setAgencyUser', 'setRegistration', 'getFeatureSwitches', 'getAgencyVersion']),
    async handleReset () {
      this.resetError();
    },
    getAgencyUser: async function () {
      var userResponse = await this.$api.getAgencyUser();
      if (userResponse.code !== 0) {
        this.setError({ errorMessage: `Unable to get Agency User: ${userResponse.friendly}` });
        this.$router.push({ path: '/error' });
        return;
      }
      this.setAgencyUser(JSON.parse(userResponse.data));
    },
    getRegistration: async function () {
      var registrationResponse = await this.$api.getRegistrationStatus();
      if (registrationResponse.code === 0) {
        // this is one of the few licensing API calls that returns a ResponseModel
        var registrationData = JSON.parse(registrationResponse.data[0]);

        if (registrationData.code === 'NoData') {
          // check to see if this is the existing route so you don't double navigate, same checks below
          if (this.$route.path !== '/registration') this.$router.push({ path: '/registration' });
        } else if (registrationData.code === 'Ok' && registrationData.data[0] !== null) {
          var status = registrationData.data[0].status;
          var registrationInformation = registrationData.data[0];
          this.setRegistration(registrationInformation);

          if (status === 'Pending' || status === 'CodeExpired') {
            if (this.$route.path !== '/registration/confirmation') this.$router.push({ path: '/registration/confirmation' });
          } else if (status === 'EmailConfirmed') {
            if (this.$route.path !== '/marketplace') this.$router.push({ path: '/marketplace' });
          } else {
            // email no longer matches that in LiveDB - user must re-register
            if (this.$route.path !== '/registration/update') this.$router.push({ path: '/registration/update' });
          }
        }
      } else {
        this.$router.push({ push: '/registration/error' });
      }
    }
  }
};
</script>
